import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppTopBarComponent } from '../app-topbar/app-topbar.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { MessagesServiceGql } from '../../messages';
import { map, Observable } from 'rxjs';
import { Message, MessagesListType } from '@biorec/partners/domain';
import { AccordionModule } from 'primeng/accordion';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-container',
	templateUrl: './app-container.component.html',
	standalone: true,
	imports: [AppTopBarComponent, RouterOutlet, DialogModule, ButtonModule, AccordionModule, CommonModule],
})
export class AppContainerComponent implements OnInit {

	public visible: boolean = false;
	protected $messages: Observable<Message[]> = null;

	constructor(private readonly msgSvc: MessagesServiceGql) {
	}

	ngOnInit() {
		this.checkImportantMessages();
		this.$messages.subscribe(m => this.visible = m.length != 0)
	}

	checkImportantMessages() {
		this.$messages = this.msgSvc.getMessagesList(MessagesListType.All).pipe(
			map(items => items.filter(item => item.important))
		);
	}

	markAsRead(id: number, hasDoctor: boolean) {
		this.msgSvc.updateMessage(
			{ msgId: id, open: true, read: true },
			hasDoctor ? MessagesListType.Personal : MessagesListType.Global
		);
		this.checkImportantMessages();
		console.warn(id);
	}
}
